
function getPaymentRemits(fields = [], paymentAmount) {
  let amount = paymentAmount;
  const additionCharges = [];
  fields.forEach((field) => {
    const fieldCharge = calaculate(field, amount);
    amount -= fieldCharge.amount;
    additionCharges.push(fieldCharge);
  });
  // const remits = fields.map(field => calaculate(field, paymentAmount));
  return { remits: additionCharges, total_amount: amount };
}
// TODO
function calaculate(field = {}, amount = 0) {
  const invoiceAmount = amount;
  const fieldJson = Object.assign(field, { amount: 0 });
  const percentage = (fieldJson.percentage) ? (fieldJson.percentage / 100) : 0;
  fieldJson.amount = (invoiceAmount * percentage);
  return fieldJson;
}


export default getPaymentRemits;
